import BaseClass from "../BaseClass.js";

/**
 * zählt die Zeichen in einem textarea
 */
export default class InputCounter extends BaseClass {

    constructor(element) {
        super(element);

        this.$inputTarget = null;
        this.limits = {min: 0, max: 0};
        this.changeListener = null;
        this.init();
    }

    init() {
        let mySelf = this;

        let inputTargetSelector = this.$element.data('target-selector');
        this.$inputTarget = $(inputTargetSelector);

        let limitMin = this.$element.data('count-min');
        if (limitMin != undefined) {
            this.limits.min = parseInt(limitMin);
        }

        let limitMax = this.$element.data('count-max');
        if (limitMax != undefined) {
            this.limits.max = parseInt(limitMax);
        }

        setTimeout(function () {
            mySelf.updateCounter();
        }, 200);

        this.changeListener = function () {
            mySelf.updateCounter();
        }
        this.$inputTarget.on('change blur keyup input', this.changeListener);
    }

    updateCounter() {
        let inputVal = this.$inputTarget.val();
        inputVal = inputVal.replace(/\n/g, "\r\n");
        inputVal = inputVal.trim();

        let count = 0;
        if (inputVal.length !== 0) {
            count = inputVal.length;
        }

        let $currentCountElement = $('<span class="textarea-counter__amount">' + count + '</span>');
        let $maxLimitElement = $('<span>/' + this.limits.max + '</span>');

        this.$element.children().remove();
        this.$element.append($currentCountElement);
        this.$element.append($maxLimitElement);

        if (count < this.limits.min) {
            $currentCountElement.removeClass('valid').addClass('invalid');
        } else if (count > this.limits.max) {
            let trimLength = this.limits.max - count;
            inputVal = inputVal.slice(0, trimLength);
            this.$inputTarget.val(inputVal);
        } else {
            $currentCountElement.removeClass('invalid').addClass('valid');
        }
    }

    destroyListener() {
        this.$inputTarget.off('change keyup input', this.changeListener);
    }
}
